import { useMemo } from 'react';

import { useCategoryTreeItem } from '../../categoryTree';
import { createMissingCategoryError } from '../../errors';

import { createWrongChannelCategoryType } from './errors';
import { getChannelsSettings } from './getChannelsSettings';

type UseChannelsSettingsProps = {
  referenceId: string;
};

export function useChannelsSettings({ referenceId }: UseChannelsSettingsProps) {
  const category = useCategoryTreeItem(referenceId);

  const settings = useMemo(() => {
    if (!category) {
      return undefined;
    }

    return getChannelsSettings(category);
  }, [category]);

  const error = useMemo(() => {
    if (!category) {
      return createMissingCategoryError();
    }

    if (!settings) {
      return createWrongChannelCategoryType();
    }
  }, [category, settings]);

  return {
    error,
    settings,
  };
}
